import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';

import {store} from './store/store'
import auth from '../plugins/auth'

Vue.use(auth);

alertify.set('notifier','position', 'top-right');

axios.interceptors.request.use(function (config) {
    var token = Vue.auth.getToken();
    if(token) {
        config.headers['Authorization']  ='Bearer ' + token;
    }
    return config;
}, function (error) {
    console.log(error);
});


axios.interceptors.response.use(undefined, err => {
    let res = err.response;
    if(res.status === 401) {
        err.response.data.forEach(e => alertify.error(e));
        setTimeout(() => window.location.href = "/logout", 2000)
    }
    if(res.status == 422) {
        for(let key in res.data) {
            res.data[key].forEach(e => alertify.error(e));
        }
    }
});



new Vue({
    el: '#fleets',
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./vue/fleet/index.js